import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function SuspenseLoading() {
    const { t } = useTranslation();
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 30,
        color: "#4d90ff",
      }}
      spin
    />
  );
  return (
    <div className='flex items-center justify-center h-full  '>
      <div className='suspenseLoading text-center'>
        <Spin indicator={antIcon} className="text-white" />
      
        <h1 className=' text-base lg:text-xl font-medium capitalize'>
          {t("common.src.loadingSuspenseLoadingSuspenseLoading.loading")}</h1>
      </div>
    </div>
  );
}
